














































import Vue from "vue";
import axios from "axios";
import Snackbar from "../components/snackbar.vue";
import {
  getQuestions,
  HealthCheckQuestion
} from "../helpers/healthcheckquestions";
import Question from "../components/HealthCheck/Question.vue";
import { EventHealthCheckVO } from "../types/REST-API-DOMAIN/EventHealthCheckVO";
import { SnackbarProps } from "../types/SnackbarProps";
import { HealthCheckQuestionResponse } from "@/types/HealthCheckQuestionResponse";

interface State {
  isHealthCheckComplete: boolean | null;
  eventId: string | null;
  eventData: EventHealthCheckVO | null;
  playerId: string | null;
  valid: boolean;
  questions: Array<HealthCheckQuestion>;
  formHasErrors: boolean;
  snackbar: SnackbarProps;
}

export default Vue.extend({
  name: "HealthCheck",
  components: {
    Snackbar,
    Question
  },
  data: (): State => {
    return {
      isHealthCheckComplete: null,
      eventId: null,
      eventData: null,
      playerId: null,
      valid: false,
      questions: [] as Array<HealthCheckQuestion>,
      formHasErrors: false,
      snackbar: {
        message: {},
        color: "green",
        snackbar: false,
        text: "",
        responseButtons: false,
        centered: false
      }
    };
  },
  mounted(): void {
    this.questions = this.getHealthQuestions();
    const eventId: any = this.$route.query.eventId
      ? this.$route.query.eventId
      : null;
    const playerId: any = this.$route.query.playerId
      ? this.$route.query.playerId
      : null;
    if (eventId && playerId) {
      this.eventId = eventId;
      this.playerId = playerId;
      this.getHealthEventData();
      this.getHealthCheckResponseStatus();
    }
  },
  methods: {
    getHealthEventData(): void {
      axios.get(`/rest-api/healthcheck/event/${this.eventId}`).then(res => {
        this.eventData = res.data;
      });
    },
    getHealthCheckResponseStatus(): void {
      axios
        .get(`rest-api/healthcheck/status/${this.eventId}/${this.playerId}`)
        .then(res => {
          this.isHealthCheckComplete = res.data;
          if (this.isHealthCheckComplete) {
            this.showCompleted();
          }
        });
    },
    setVal(e: HealthCheckQuestion, i: number): void {
      this.questions[i] = e;
    },
    getHealthQuestions() {
      return getQuestions();
    },
    validate(): void {
      //@ts-ignore
      this.formHasErrors = !this.$refs.form.validate();
      if (this.formHasErrors) {
        console.log("ERRORS");
      } else {
        this.saveHealthCheck(this.buildResponse());
        // this.$refs.form.reset();
      }
    },
    saveHealthCheck(response: HealthCheckQuestionResponse) {
      this.isHealthCheckComplete = true;
      if (response.alert) {
        this.showAlertMessage();
      } else {
        this.showSuccess();
      }
      axios.post("/rest-api/healthcheck/save", response).catch(() => {
        this.errorSaving();
      });
      // http://localhost:8084/healthcheck?eventId=d1876c06-2cd2-4a80-9df0-81b95545a12a&playerId=1d356799-6b82-497c-ba53-ec9d201866d9
    },
    buildResponse(): HealthCheckQuestionResponse {
      const questions: Array<HealthCheckQuestion> = this.flattenResponse(
        this.questions
      );
      const response: HealthCheckQuestionResponse = {
        playerId: this.playerId,
        eventId: this.eventId,
        questions: questions,
        alert: questions.some(q => q.answer == true)
      };
      return response;
    },
    flattenResponse(
      questions: Array<HealthCheckQuestion>
    ): Array<HealthCheckQuestion> {
      let result: Array<HealthCheckQuestion> = [];
      for (const q of questions) {
        if (Array.isArray(q.answer)) {
          result = result.concat(this.flattenResponse(q.answer));
        } else {
          result.push({
            question: q.question,
            answer: q.answer,
            rules: null,
            type: null
          });
        }
      }
      return result;
    },
    getFormattedStartDate(): string {
      if (!this.eventData) return "";
      const date = new Date(this.eventData.event.start);
      const time = date.toLocaleString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
      return `${date.toLocaleDateString()} ${time}`;
    },
    errorSaving(): void {
      this.snackbar.color = "error";
      this.snackbar.text =
        "A problem occurred while saving your response, please refresh and try again";
      this.snackbar.centered = true;
      this.snackbar.snackbar = true;
    },
    showAlertMessage(): void {
      this.snackbar.color = "info";
      this.snackbar.text =
        "Your response indicates that you may have been exposed to COVID-19. Please follow your club guidelines regarding COVID-19 symptoms and exposure.";
      this.snackbar.centered = true;
      this.snackbar.snackbar = true;
    },
    showSuccess(): void {
      this.snackbar.color = "success";
      this.snackbar.text =
        "Submitted! Your response indicates you are clear to attend today's event!";
      this.snackbar.centered = true;
      this.snackbar.snackbar = true;
    },
    showCompleted(): void {
      this.snackbar.color = "success";
      this.snackbar.text =
        "Your COVID Health Check-In has already been completed! Please contact your coach for updates.";
      this.snackbar.centered = true;
      this.snackbar.snackbar = true;
    }
  }
});
